import classes from "./login-content.module.scss";

import { useCallback, useMemo, useState } from "react";

import { useAuthContext } from "@honeycomb/mystique";
import { Button, Divider, Input } from "@honeycomb/ui";
import { LogIn, Mail } from "lucide-react";

// Standard email format. The [^\s@]+ local part allows "+" addressing
// (e.g. testuser+test@gmail.com) for multiple users on a single account.
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const LoginContentForm = () => {
  const { login, availableProviders } = useAuthContext();
  const [email, setEmail] = useState("");

  const hasAuth0 = availableProviders.includes("auth0");
  const hasIdentity = availableProviders.includes("hivemind");

  const isEmailValid = useMemo(() => EMAIL_REGEX.test(email.trim()), [email]);

  const handleSubmit = useCallback(
    (e: React.FormEvent) => {
      e.preventDefault();
      if (!isEmailValid) return;
      login({ provider: "hivemind", loginHint: email.trim() });
    },
    [email, isEmailValid, login]
  );

  const handleAuth0Login = useCallback(
    (connectionType?: "email") => {
      return () => {
        login({ connection: connectionType });
      };
    },
    [login]
  );

  return (
    <form className={classes["login-form"]} onSubmit={handleSubmit}>
      <div className={classes["login-actions"]}>
        {hasAuth0 && (
          <>
            <Button type="primary" data-cy="log-in-email" onClick={handleAuth0Login("email")}>
              <Mail /> Send Email Passcode
            </Button>
            <Button type="text" data-cy="log-in-password" onClick={handleAuth0Login()}>
              <LogIn /> Password Sign In
            </Button>
          </>
        )}
        {hasAuth0 && hasIdentity && <Divider>or</Divider>}
        {hasIdentity && (
          <>
            <Input
              type="email"
              name="email"
              autoComplete="email"
              placeholder="Enter your email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-cy="login-email-input"
              autoFocus={!hasAuth0}
            />
            <Button type="primary" data-cy="log-in" htmlType="submit" disabled={!isEmailValid}>
              <LogIn /> Sign In
            </Button>
          </>
        )}
      </div>
    </form>
  );
};
